import {
    apiRequest,
    pejabatPenetapCreate,
    employeeList,
    polaKerjaList
} from "../../../../../services/adapters/kepegawaian/pejabatPenetapService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pejabatPenetapCreate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", employeeList, {
            params: query
        }, true)
    }

    fetchPolaKerja = async (query) => {
        return await apiRequest("get", polaKerjaList, {
            params: query
        }, true)
    }
}

export default CreateRepository